import { useState, useEffect, useRef } from "react";
import './Asia.css'
import { LuUser } from "react-icons/lu";
import sensory_points from '../../../assets/images/Key_Sensory_Points.jpg'
import SCReference from "./SCReference";
import handleSubmit from './ScoreUpload'
import { useAlert } from "react-alert";
const levels = [
  "C2", "C3", "C4", "C5", "C6", "C7", "C8", "T1",
  "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9",
  "T10", "T11", "T12", "L1", "L2", "L3", "L4", "L5",
  "S1", "S2", "S3", "S4-5"
];


const motorLabels = {
  C5: "Elbow flexors",
  C6: "Wrist extensors",
  C7: "Elbow extensors",
  C8: "Finger flexors",
  T1: "Finger abductors (little finger)",
  L2: "Hip flexors",
  L3: "Knee extensors",
  L4: "Ankle dorsiflexors",
  L5: "Long toe extensors",
  S1: "Ankle plantar flexors"
};

const Asia = ({ data }) => {
  const alert = useAlert()
  const [formData, setFormData] = useState({});
  const [totals, setTotals] = useState({
    LTR: 0,
    PPR: 0,
    LTL: 0,
    PPL: 0,
    UER: 0,
    UEL: 0,
    LER: 0,
    LEL: 0,
    MOTOR_R: 0,
    MOTOR_L: 0,
    LT_TOTAL: 0,
    PP_TOTAL: 0,
    UEMS_TOTAL: 0,
    LEMS_TOTAL: 0
  });
  const [loading, setLoading] = useState(false)
  const formRef = useRef(null);
  const [info, setInfo] = useState({
    therapy_consultation: data?.therapy_id || '',
    id: data?.id || '',
    name: data?.name || '',
    diagnosis: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Calculate totals whenever formData changes
  useEffect(() => {
    const calculateTotals = () => {
      let newTotals = {
        LTR: 0,
        PPR: 0,
        LTL: 0,
        PPL: 0,
        UER: 0,
        UEL: 0,
        LER: 0,
        LEL: 0
      };

      // Calculate sensory totals
      levels.forEach(level => {
        const ltrValue = parseInt(formData[`${level}_LTR`]) || 0;
        const pprValue = parseInt(formData[`${level}_PPR`]) || 0;
        const ltlValue = parseInt(formData[`${level}_LTL`]) || 0;
        const pplValue = parseInt(formData[`${level}_PPL`]) || 0;

        newTotals.LTR += ltrValue;
        newTotals.PPR += pprValue;
        newTotals.LTL += ltlValue;
        newTotals.PPL += pplValue;
      });

      // Calculate motor totals - Fixed to include all motor levels
      const upperMotorLevels = ["C5", "C6", "C7", "C8", "T1"];
      const lowerMotorLevels = ["L2", "L3", "L4", "L5", "S1"];

      upperMotorLevels.forEach(level => {
        const rightValue = parseInt(formData[`${level}_motor_R`]) || 0;
        const leftValue = parseInt(formData[`${level}_motor_L`]) || 0;
        newTotals.UER += rightValue;
        newTotals.UEL += leftValue;
      });

      lowerMotorLevels.forEach(level => {
        const rightValue = parseInt(formData[`${level}_motor_R`]) || 0;
        const leftValue = parseInt(formData[`${level}_motor_L`]) || 0;
        newTotals.LER += rightValue;
        newTotals.LEL += leftValue;
      });

      // Calculate combined totals
      newTotals.LT_TOTAL = newTotals.LTR + newTotals.LTL;
      newTotals.PP_TOTAL = newTotals.PPR + newTotals.PPL;
      newTotals.UEMS_TOTAL = newTotals.UER + newTotals.UEL;
      newTotals.LEMS_TOTAL = newTotals.LER + newTotals.LEL;

      // Fixed: Total motor scores for right and left (UER+LER and UEL+LEL)
      newTotals.MOTOR_R = newTotals.UER + newTotals.LER;
      newTotals.MOTOR_L = newTotals.UEL + newTotals.LEL;

      setTotals(newTotals);
    };

    calculateTotals();
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCancel = () => {
    setFormData({});
    setInfo({
      therapy_consultation: data?.therapy_id || '',
      id: data?.id || '',
      name: data?.name || '',
      diagnosis: '',
    });
  };

  const handleFormSubmit = async () => {
    setLoading(true)
    const result = await handleSubmit(info, formRef, 'asia_scale', alert, 0);

    if (result && result.success) {
      handleCancel()
    }
    if (result) {
      setLoading(false)
    }
  };

  const renderRightColumn = () => {
    return (
      <div className="colmn">
        <div className="column-subheaders row">
          <div className="asia-header" style={{ flex: 3 }}><strong>RIGHT</strong></div>
          <div className="sensory-header" style={{ flex: 2 }}>
            <strong>MOTOR</strong><br />
            <span className="small">KEY MUSCLES</span>
          </div>
          <div className="sensory-header" style={{ flex: 2 }}>
            <strong>SENSORY</strong><br />
            <span className="small">KEY SENSORY POINTS</span><br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className="small">Light Touch (LTR)</span>
              <span className="small">Pin Prick (PPR)</span>
            </div>
          </div>
        </div>
        {levels.slice(0, 3).map((level) => (
          <div key={level} className="level-row">
            <div className="level-label">{level}</div>
            <input className="sensory-input" name={`${level}_LTR`} onChange={handleInputChange} />
            <input className="sensory-input" name={`${level}_PPR`} onChange={handleInputChange} />
          </div>
        ))}

        <div style={{ display: "flex" }}>
          <div className="section-divider col-3" style={{ padding: 0 }}>
            <strong>UER</strong><br />
            <span className="small">(Upper Extremity Right)</span>
          </div>
          <div className="col-9" style={{ padding: 0 }}>
            {levels.slice(3, 8).map((level) => (
              <div key={level} className="level-row">
                <div className="level-label motor-label">{motorLabels[level]} {level}</div>
                <input className="mtr-input" name={`${level}_motor_R`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_LTR`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPR`} onChange={handleInputChange} />
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div className="comments-section col-8">
            <strong>Comments</strong> (Non-key Muscle? Reason for NT? Pain?)<br />
            <textarea className="comments-box" name="comments_right" onChange={handleInputChange}></textarea>
          </div>
          <div className="col-4" style={{ padding: 0 }}>
            {levels.slice(8, 20).map((level) => (
              <div key={level} className="level-row">
                <div className="level-label">{level}</div>
                <input className="sensory-input" name={`${level}_LTR`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPR`} onChange={handleInputChange} />
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="section-divider col-4">
            <strong>LER</strong><br />
            <span className="small">(Lower Extremity Right)</span>
          </div>
          <div className='col-8' style={{ padding: 0 }}>
            {levels.slice(20, 25).map((level) => (
              <div key={level} className="level-row">
                <div className="level-label motor-label">{motorLabels[level]} {level}</div>
                <input className="mtr-input" name={`${level}_motor_R`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_LTR`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPR`} onChange={handleInputChange} />
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="anal-function col-8">
            <strong>(VAC) Voluntary Anal Contraction</strong><br />
            <span className="small">(Yes/No)</span>
            <input className="anal-input" name="VAC" onChange={handleInputChange} />
          </div>
          <div className="col-4" style={{ padding: 0 }}>
            {levels.slice(25).map((level) => (
              <div key={level} className="level-row">
                <div className="level-label">{level}</div>
                <input className="sensory-input" name={`${level}_LTR`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPR`} onChange={handleInputChange} />
              </div>
            ))}
          </div>
        </div>

        <div className="totals">
          <label><b>RIGHT TOTALS</b></label>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.MOTOR_R} disabled />
              <span className="small">(50)</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.LTR} disabled />
              <span className="small">(56)</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.PPR} disabled />
              <span className="small">(56)</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLeftColumn = () => {
    return (
      <div className="colmn">
        <div className="column-subheaders row">
          <div className="sensory-header" style={{ flex: 2 }}>
            <strong>SENSORY</strong><br />
            <span className="small">KEY SENSORY POINTS</span><br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className="small">Light Touch (LTL)</span>
              <span className="small">Pin Prick (PPL)</span>
            </div>
          </div>
          <div className="sensory-header" style={{ flex: 2 }}>
            <strong>MOTOR</strong><br />
            <span className="small">KEY MUSCLES</span>
          </div>
          <div className="asia-header" style={{ flex: 3 }}><strong>LEFT</strong></div>
        </div>

        {levels.slice(0, 3).map((level) => (
          <div key={level} className="level-row level-row-left">
            <input className="sensory-input" name={`${level}_LTL`} onChange={handleInputChange} />
            <input className="sensory-input" name={`${level}_PPL`} onChange={handleInputChange} />
            <div className="level-label">{level}</div>
          </div>
        ))}

        <div style={{ display: 'flex' }}>
          <div className='col-9' style={{ padding: 0 }}>
            {levels.slice(3, 8).map((level) => (
              <div key={level} className="level-row level-row-left">
                <input className="sensory-input" name={`${level}_LTL`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPL`} onChange={handleInputChange} />
                <input className="mtr-input" name={`${level}_motor_L`} onChange={handleInputChange} />
                <div className="level-label motor-label">{level} {motorLabels[level]}</div>
              </div>
            ))}
          </div>
          <div className="section-divider col-3" style={{ padding: 0 }}>
            <strong>UEL</strong><br />
            <span className="small">(Upper Extremity Left)</span>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="col-4" style={{ padding: 0 }}>
            {levels.slice(8, 20).map((level) => (
              <div key={level} className="level-row level-row-left">
                <input className="sensory-input" name={`${level}_LTL`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPL`} onChange={handleInputChange} />
                <div className="level-label">{level}</div>
              </div>
            ))}
          </div>
          <div className="col-8">
            <div className="scoring-guide">
              <strong>MOTOR</strong><br />
              <span className="small">(SCORING ON REVERSE SIDE)</span><br />
              <span className="small">0 = total paralysis</span><br />
              <span className="small">1 = palpable or visible contraction</span><br />
              <span className="small">2 = active movement, gravity eliminated</span><br />
              <span className="small">3 = active movement, against gravity</span><br />
              <span className="small">4 = active movement, against some resistance</span><br />
              <span className="small">5 = active movement, against full resistance</span><br />
              <span className="small">NT = not testable</span>
            </div>
            <div className="scoring-guide">
              <strong>SENSORY</strong><br />
              <span className="small">(SCORING ON REVERSE SIDE)</span><br />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <label>
                  <span className="small">0 = absent</span><br />
                  <span className="small">1 = altered</span>
                </label>
                <label>
                  <span className="small">2 = normal</span><br />
                  <span className="small">NT = not testable</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="col-8" style={{ padding: 0 }}>
            {levels.slice(20, 25).map((level) => (
              <div key={level} className="level-row level-row-left">
                <input className="sensory-input" name={`${level}_LTL`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPL`} onChange={handleInputChange} />
                <input className="mtr-input" name={`${level}_motor_L`} onChange={handleInputChange} />
                <div className="level-label motor-label">{level} {motorLabels[level]}</div>
              </div>
            ))}
          </div>
          <div className="section-divider col-4">
            <strong>LEL</strong><br />
            <span className="small">(Lower Extremity Left)</span>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="col-4" style={{ padding: 0 }}>
            {levels.slice(25).map((level) => (
              <div key={level} className="level-row level-row-left">
                <input className="sensory-input" name={`${level}_LTL`} onChange={handleInputChange} />
                <input className="sensory-input" name={`${level}_PPL`} onChange={handleInputChange} />
                <div className="level-label">{level}</div>
              </div>
            ))}
          </div>
          <div className="anal-function col-8" style={{ textAlign: 'left' }}>
            <strong>(DAP) Deep Anal Pressure</strong><br />
            <span className="small">(Yes/No)</span>
            <input className="anal-input" name="DAP" onChange={handleInputChange} />
          </div>
        </div>
        <div className="totals" style={{ justifyContent: 'start' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.LTL} disabled />
              <span className="small">(56)</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.PPL} disabled />
              <span className="small">(56)</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input className="total-input" value={totals.MOTOR_L} disabled />
              <span className="small">(50)</span>
            </div>
          </div>
          <label><b>LEFT TOTALS</b></label>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="general-form-content" ref={formRef}>
        <div className="section-header">
          <h2>ASIA Score Scale</h2>
        </div>
        <div className="asia-form section">
          <div className="main-grid">
            {renderRightColumn()}

            <div className="center-column">
              <img src={sensory_points} alt='sensory points' style={{ margin: 'auto' }} />
            </div>

            {renderLeftColumn()}
          </div>

          <div className="bottom-section">
            <div className="subscores">
              <div className="motor-subscores">
                <label><b>MOTOR SUBSCORES</b></label><br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <div className="score-row">
                      <span>UER</span> <input className="score-input" value={totals.UER} readOnly />
                      + <span>UEL</span> <input className="score-input" value={totals.UEL} readOnly />
                      = <span>UEMS TOTAL</span> <input className="score-input" value={totals.UEMS_TOTAL} readOnly />
                    </div>
                    <div className="score-row">
                      <span style={{ marginLeft: '9px' }}>MAX (25)</span> <span style={{ marginLeft: '38px' }}>(25)</span> <span style={{ marginLeft: '75px' }}>(50)</span>
                    </div>
                  </div>
                  <div>
                    <div className="score-row">
                      <span>LER</span> <input className="score-input" value={totals.LER} readOnly />
                      + <span>LEL</span> <input className="score-input" value={totals.LEL} readOnly />
                      = <span>LEMS TOTAL</span> <input className="score-input" value={totals.LEMS_TOTAL} readOnly />
                    </div>
                    <div className="score-row">
                      <span style={{ marginLeft: '9px' }}>MAX (25)</span> <span style={{ marginLeft: '38px' }}>(25)</span> <span style={{ marginLeft: '75px' }}>(50)</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="sensory-subscores">
                <label><b>SENSORY SUBSCORES</b></label><br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <div className="score-row">
                      <span>LTR</span> <input className="score-input" value={totals.LTR} readOnly />
                      + <span>LTL</span> <input className="score-input" value={totals.LTL} readOnly />
                      = <span>LT TOTAL</span> <input className="score-input" value={totals.LT_TOTAL} readOnly />
                    </div>
                    <div className="score-row">
                      <span style={{ marginLeft: '9px' }}>MAX (56)</span> <span style={{ marginLeft: '38px' }}>(56)</span> <span style={{ marginLeft: '75px' }}>(112)</span>
                    </div>
                  </div>
                  <div>
                    <div className="score-row">
                      <span>PPR</span> <input className="score-input" value={totals.PPR} readOnly />
                      + <span>PPL</span> <input className="score-input" value={totals.PPL} readOnly />
                      = <span>PP TOTAL</span> <input className="score-input" value={totals.PP_TOTAL} readOnly />
                    </div>
                    <div className="score-row">
                      <span style={{ marginLeft: '9px' }}>MAX (56)</span> <span style={{ marginLeft: '38px' }}>(56)</span> <span style={{ marginLeft: '75px' }}>(112)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="final-scores">
              <div className='final-scores-sub' style={{ flex: '1' }}>
                <span className='bold-span'>NEUROLOGICAL LEVELS</span>
                <span className="small">Steps 1-5 for classification as on reverse</span>
              </div>
              <div className='final-scores-sub' style={{ alignContent: 'end' }}>
                <div className="score-row" style={{ marginRight: '15px' }}>
                  <span className='bold-span' style={{ marginRight: '20px' }}>R</span> <span className='bold-span'>L</span>
                </div>
                <div className="score-row" >
                  <span className='bold-span'>1.SENSORY</span>
                  <input className="score-input" name="SENSORY_R" onChange={handleInputChange} />
                  <input className="score-input" name="SENSORY_L" onChange={handleInputChange} />
                </div>
                <div className="score-row">
                  <span className='bold-span'>2.MOTOR</span>
                  <input className="score-input" name="MOTOR_R" onChange={handleInputChange} />
                  <input className="score-input" name="MOTOR_L" onChange={handleInputChange} />
                </div>
              </div>
              <div className='final-scores-sub'>
                <div className="score-row">
                  <span className='bold-span'>3.NEUROLOGICAL LEVEL OF INJURY (NLI)</span>
                  <input className="score-input" name="NLI" onChange={handleInputChange} />
                </div>
              </div>
              <div className='final-scores-sub' style={{ flex: '2' }}>
                <div className="score-row">
                  <span className='bold-span'>4.COMPLETE OR INCOMPLETE?</span>
                  <input className="score-input" name="complete" onChange={handleInputChange} />
                </div>
                <div className="score-row">
                  <span className="small">Incomplete = Any sensory or motor function in S4-5</span>
                </div>
                <div className="score-row">
                  <span className='bold-span'>5.ASIA IMPAIRMENT SCALE (AIS)</span>
                  <input className="score-input" name="AIS" onChange={handleInputChange} />
                </div>
              </div>
              <div className='final-scores-sub'>
                <span className="small">(in complete injuries only)</span>
                <span className='bold-span'>ZONE OF PARTIAL PRESERVATION</span>
                <span className="small">Most caudal level with any innervation</span>
              </div>
              <div className='final-scores-sub' style={{ alignContent: 'end' }}>
                <div className="score-row" style={{ marginRight: '15px' }}>
                  <span className='bold-span' style={{ marginRight: '20px' }}>R</span> <span className='bold-span'>L</span>
                </div>
                <div className="score-row">
                  <span className='bold-span'>SENSORY</span>
                  <input className="score-input" name="ZPP_SENSORY_R" onChange={handleInputChange} />
                  <input className="score-input" name="ZPP_SENSORY_L" onChange={handleInputChange} />
                </div>
                <div className="score-row">
                  <span className='bold-span'>MOTOR</span>
                  <input className="score-input" name="ZPP_MOTOR_R" onChange={handleInputChange} />
                  <input className="score-input" name="ZPP_MOTOR_L" onChange={handleInputChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <SCReference />
      </div>
      <div className="general-form-actions">
        <button type="button" onClick={handleCancel} className="cancel-btn">Cancel</button>
        <button type="submit" onClick={handleFormSubmit} disabled={loading} className="submit-btn" style={{ cursor: loading ? 'wait' : 'pointer' }} >{loading ? 'Saving...' : 'Save'}</button>
      </div>
    </>
  );
};

export default Asia;